import type { InstrumentationProvider } from './Instrumentation'

/**
 * Initializes an instrumentation provider with the given adapter and options.
 *
 * @param Adapter The instrumentation provider class/constructor.
 * @param options The options to pass to the provider's constructor.
 * @returns An instance of the instrumentation provider.
 */
export function init<
  TProvider extends InstrumentationProvider,
  TAdapter extends Array<any> = ConstructorParameters<
    new (...args: Array<any>) => TProvider
  >,
>(
  Adapter: new (...args: TAdapter) => TProvider,
  ...options: TAdapter
): TProvider {
  return new Adapter(...options)
}

export type Instrumentation = ReturnType<typeof init>
